"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQueryParams = void 0;
var tslib_1 = require("tslib");
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function addQueryParams(url, params) {
    var queryParams = query_string_1.default.stringify(params);
    return "".concat(url).concat(url.includes('?') ? '&' : '?').concat(queryParams);
}
exports.addQueryParams = addQueryParams;
